module.exports = __webpack_public_path__ + "img/lara.4810421f.jpeg";